import { render, staticRenderFns } from "./ModalServico.vue?vue&type=template&id=3bb23082"
import script from "./ModalServico.vue?vue&type=script&lang=js"
export * from "./ModalServico.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports